import { render, staticRenderFns } from "./filtro-nivel-academico.vue?vue&type=template&id=cc413be2&"
import script from "./filtro-nivel-academico.vue?vue&type=script&lang=js&"
export * from "./filtro-nivel-academico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports